import React, { useState, useRef, useEffect } from 'react';
import './MultiSelectSearch.css';

const MultiSelectSearch = ({ options, value = [], onChange, placeholder = 'Search…', disabled = false, labelKey = 'label', valueKey = 'value' }) => {
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const filtered = options.filter(opt => {
        if (value.includes(opt[valueKey])) return false;
        return String(opt[labelKey]).toLowerCase().includes(search.toLowerCase());
    });

    const select = (opt) => {
        onChange([...value, opt[valueKey]]);
        setSearch('');
    };

    const remove = (val) => onChange(value.filter(v => v !== val));

    const selectedOptions = value.map(v => options.find(o => o[valueKey] === v)).filter(Boolean);

    return (
        <div className="mss-container" ref={containerRef}>
            <div className={`mss-control${open ? ' mss-control-open' : ''}${disabled ? ' mss-control-disabled' : ''}`} onClick={() => !disabled && setOpen(true)}>
                {selectedOptions.map(opt => (
                    <span key={opt[valueKey]} className="mss-chip">
                        {opt[labelKey]}
                        <button type="button" className="mss-chip-remove" onMouseDown={e => { e.stopPropagation(); remove(opt[valueKey]); }}>×</button>
                    </span>
                ))}
                <input
                    className="mss-input"
                    value={search}
                    onChange={e => { setSearch(e.target.value); setOpen(true); }}
                    onFocus={() => setOpen(true)}
                    placeholder={value.length === 0 ? placeholder : ''}
                    disabled={disabled}
                />
            </div>
            {open && !disabled && (
                <div className="mss-dropdown">
                    {filtered.length === 0
                        ? <div className="mss-empty">{options.length === 0 ? 'Loading…' : 'No results'}</div>
                        : filtered.map(opt => (
                            <div key={opt[valueKey]} className="mss-option" onMouseDown={e => { e.preventDefault(); select(opt); }}>
                                {opt[labelKey]}
                            </div>
                        ))
                    }
                </div>
            )}
        </div>
    );
};

export default MultiSelectSearch;
